import type { Dispatch } from "react";
import type { TurnstileInstance } from "@marsidev/react-turnstile";
import { Turnstile } from "@marsidev/react-turnstile";
import { t } from "@/i18n-js/instance";
import { useToast } from "@circle-react-uikit/ToastV2";
import type { TurnstileActionType } from "../hooks/useTurnstile";
import { localeScope } from "./index";

interface TurnstileWrapperProps {
  dispatch: Dispatch<{ type: TurnstileActionType }>;
  shouldShowTurnstile: boolean;
  turnstileRef: React.RefObject<TurnstileInstance>;
}

export const TurnstileWrapper = ({
  turnstileRef,
  shouldShowTurnstile,
  dispatch,
}: TurnstileWrapperProps) => {
  const toast = useToast();

  return (
    <Turnstile
      ref={turnstileRef}
      options={{ theme: "light" }}
      className={shouldShowTurnstile ? "" : "hidden"}
      onError={() => {
        dispatch({ type: "SET_FAILED" });
        const message = t(`${localeScope}.errors.failed`);
        toast.error(message);
      }}
      onExpire={() => dispatch({ type: "SET_FAILED" })}
      onSuccess={() => dispatch({ type: "SET_SUCCESS" })}
      onBeforeInteractive={() => dispatch({ type: "SET_INTERACTIVE" })}
      siteKey={window.TURNSTILE_CAPTCHA_SITE_KEY || ""}
    />
  );
};
